import { render, staticRenderFns } from "./PromoteContractDetail.vue?vue&type=template&id=a536bb4c&scoped=true"
import script from "./PromoteContractDetail.vue?vue&type=script&lang=js"
export * from "./PromoteContractDetail.vue?vue&type=script&lang=js"
import style0 from "./PromoteContractDetail.vue?vue&type=style&index=0&id=a536bb4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a536bb4c",
  null
  
)

export default component.exports